import styled, { css } from "styled-components";

//constants
import COLORS from "../../constants/colors";
import { flexCenter } from "../../mixins/style-mixins";
import { scrollBarStyle, scrollBarStyle__hidden } from "../../mixins/scrollbar";
import { BottomSheetProps } from "./BottomSheet.types";

export const BottomSheetWrapper = styled.div<Partial<BottomSheetProps>>`
    .ReactSwipeableBottomSheet--open {
        ${({ borderRadius }) =>
            borderRadius || borderRadius === 0
                ? css`
                      border-top-left-radius: ${borderRadius}px;
                      border-top-right-radius: ${borderRadius}px;
                  `
                : css`
                      border-top-left-radius: 8px;
                      border-top-right-radius: 8px;
                  `}

        ${({ fullScreen }) =>
            fullScreen
                ? css`
                      border-top-left-radius: 0px;
                      border-top-right-radius: 0px;
                  `
                : ""}

        position: relative;
        ${scrollBarStyle__hidden}
    }
`;

export const BottomSheetContentWrapper = styled.div<Partial<BottomSheetProps>>`
    display: flex;
    flex-direction: column;
    /* gap: 10px; */
    max-height: var(--viewport-height-full, 100dvh);
    height: 100%;
    background-color: ${({ backgroundColor }) => backgroundColor};
    ${({ disableSheetZoom }) =>
        disableSheetZoom
            ? css`
                  touch-action: pan-y;
              `
            : ""}
    [data-popup-header] {
        padding: ${({ padded }) => padded && "20px 20px 10px 20px"} !important;
        display: flex;
        justify-content: space-between;
        gap: 5px;
        width: 100%;
    }
    [data-popup-body] {
        ${({ hideBodyScrollbar }) =>
            hideBodyScrollbar ? scrollBarStyle__hidden : scrollBarStyle}
        overflow: ${({ disableSheetZoom }) =>
            disableSheetZoom ? "hidden" : "hidden auto"};
        padding: ${({ padded }) => padded && "20px"};
        flex-grow: 1;
        ${({ disableSheetZoom }) =>
            disableSheetZoom
                ? css`
                      flex: 1 1 auto;
                      min-height: 0;
                  `
                : ""}
    }
    [data-popup-footer] {
        padding: ${({ padded }) => padded && "10px 20px"};
        ${({ disableSheetZoom }) =>
            disableSheetZoom
                ? css`
                      flex-shrink: 0;
                  `
                : ""}
    }
`;

export const BottomSheetCrossIconWrapper = styled.div`
    ${flexCenter}
    background-color: ${COLORS.GREY_200};
    border-radius: 50%;
    width: 36px;
    height: 36px;
    margin-left: auto;
    min-width: 36px;
`;

export const BottomSheetSectionWrapper = styled.div<
    Partial<BottomSheetProps>
>``;
